/**
 * Extra tracking for this flow's titles and headings. `Text` takes a raw CSS
 * string via its `style` prop, so this is shared as a string rather than an
 * emotion object.
 *
 * Titles here are rendered in Title Case over dark panels, where the default
 * 0px tracking reads tight; the design system already uses 1.2–1.68px on its
 * caption variants, so this stays in that range.
 */
export const TITLE_LETTER_SPACING = 'letter-spacing: 1.5px;'

/** Section headings (ORGANIZATION, PRIMARY CONTACT) are all-caps and need more. */
export const SECTION_LETTER_SPACING = 'letter-spacing: 2px;'

/** Field labels ("Legal Business Name *", "Email *") — smaller text, less tracking. */
export const LABEL_LETTER_SPACING = 'letter-spacing: 0.8px;'
